import { Row, Col, Card, Divider } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useGetRole } from "../../lib/hooks/getRole";
import ROUTES from "../../configs/routesConfig";
import { CardData } from "./components/CardData";
import { useFetchData } from "./hooks/useFetchData";
import { TimeZone } from "./TimeZone";
import { Header } from "./components/Header";
import "./styles.scss";

export const Profile = () => {
  const [role, isAdmin] = useGetRole();

  const { data, isLoading } = useFetchData();

  return (
    <Row className="d-block page-content profile overflow-hidden">
      <Header title="Profile" navigateTo={ROUTES.ACCOUNTS} />
      <Row className="justify-center pt-6 overflow-y-auto profile__container">
        <Col>
          <Row>
            <Card className="card card-data left">
              {isLoading ? (
                <div className="d-flex justify-center align-center loader__container h-100">
                  <LoadingOutlined className="loader" />
                </div>
              ) : (
                <Col>
                  <h3
                    className="card-header elipsis h h2"
                    title={data.firstName}
                  >{`${data.firstName}`}</h3>
                  <h3
                    className="card-header elipsis h h2"
                    title={data.lastName}
                  >{`${data.lastName}`}</h3>
                  <Row className="mt-6">
                    <Col className="w-100">
                      {data.userName && (
                        <CardData
                          email={data.email}
                          label="Username"
                          data={data.userName || "-"}
                          isBorder
                          isNotChange={true}
                        />
                      )}

                      <CardData
                        email={data.email}
                        label="Email"
                        data={data.email}
                        isBorder
                        path={ROUTES.PROFILE_CHANGE_EMAIL}
                      />

                      <CardData
                        email={data.email}
                        label="Phone"
                        data={data.phone || undefined}
                        isBorder
                        path={ROUTES.PROFILE_CHANGE_PHONE}
                      />

                      <CardData
                        email={data.email}
                        label="Password"
                        data="**********"
                        path={ROUTES.PROFILE_CHANGE_PASSWORD}
                      />
                    </Col>
                  </Row>
                </Col>
              )}
            </Card>
            <Card className={`${isAdmin ? "admin-right" : ""} card right ml-4`}>
              {isAdmin && (
                <>
                  <div className="info">
                    <p className="mt-0 my-1 text title">Role</p>
                    <p className="text ls-5 my-0">{role}</p>
                  </div>
                  <Divider className="my-4" />
                </>
              )}
              <TimeZone />
            </Card>
          </Row>
        </Col>
      </Row>
    </Row>
  );
};
